import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import BaseButton from "../../../main/components/BaseButton";
import DangerBaseButton from "../../../main/components/DangerBaseButton";

export function ClearPVSystDataConfirmationModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClear: () => void;
}) {
  const { open, setOpen } = props;
  const onClose = () => setOpen(false);
  const onClear = () => {
    props.onClear();
    onClose();
  };
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        Limpar dados de PVSyst
      </DialogHeader>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        dividers
      >
        <Typography gutterBottom>
          Tem certeza que deseja limpar os dados de PVSyst? Você irá perder as
          informações preenchidas no formulário.
        </Typography>
      </DialogContent>
      <DialogActions>
        <DangerBaseButton title="Limpar" onClick={onClear} />
        <BaseButton
          sx={{ width: "fit-content" }}
          title="Fechar"
          onClick={onClose}
        />
      </DialogActions>
    </Dialog>
  );
}
